import React from 'react'
import { useTranslation } from 'react-i18next'
import TablePagination from '@mui/material/TablePagination'
import Box from '@mui/material/Box'

import {
  CardPaginationProps,
  MouseEvent,
  ChangeEvent,
} from 'types/TextAnalysis'
import { PaginationRowsOptions } from '../Constants'

const CardPagination = ({
  count,
  page,
  pageSize,
  onPageChange,
  onRowsPerPageChange,
}: CardPaginationProps) => {
  const { t } = useTranslation()

  const handlePaginationChange = (_: MouseEvent, newPage: number) => {
    onPageChange(newPage)
  }

  const handleChangeRowsPerPage = (event: ChangeEvent) => {
    const pageSize = Number(event.target.value)
    onRowsPerPageChange(pageSize)
    onPageChange(0)
  }

  return (
    <Box
      data-testid="ta-card-footer"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: {
          xs: 'center',
          md: 'flex-end',
        },
      }}
    >
      <Box
        sx={{
          pr: {
            xs: 0,
            lg: 3,
          },
        }}
      >
        <TablePagination
          component="div"
          id="ta-pagination"
          labelRowsPerPage={`${t('participant.grid.rowsPerPage')}:`}
          count={count}
          page={page}
          onPageChange={handlePaginationChange}
          rowsPerPage={pageSize}
          rowsPerPageOptions={PaginationRowsOptions}
          onRowsPerPageChange={handleChangeRowsPerPage}
          SelectProps={{
            inputProps: {
              'aria-label': 'rows per page',
              'aria-labelledby': 'rowsperPage',
            },
            id: 'rowsperPage',
            MenuProps: {
              disablePortal: true,
            },
          }}
          sx={{ p: 0 }}
        />
      </Box>
    </Box>
  )
}

export { CardPagination }
